import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import photos from './photos'
import products from './products'
import project from './project'
import sidebar from './sidebar'
import wallpapers from './wallpapers'
import frames from './frames'

const history = createBrowserHistory()
const reducers = combineReducers({
  sidebar,
  project,
  photos,
  wallpapers,
  products,
  frames,
})

const composeEnhancers =
  process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose

const store = createStore(
  connectRouter(history)(reducers),
  composeEnhancers(applyMiddleware(thunk, routerMiddleware(history)))
)

export default store
export { history }



// WEBPACK FOOTER //
// ./src/reducers/index.js